import SprintGame from './SprintGame';

export default SprintGame;
